import type {
  RyftAccountCreateRequestType,
  RyftAccountCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRyftManagementAccountCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({
      data,
      idempotencyKey,
    }: {
      data: RyftAccountCreateRequestType;
      idempotencyKey: string;
    }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: "ryft-management/accounts",
        data,
        idempotencyKey,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as RyftAccountCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.RyftManagementAccount,
        ],
      });
    },
  });
};
